import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '読者アンケート | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="アンケートに答えてプレゼントが当たる！夏号読者アンケート" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2024夏号 No.167 目次",
              path: "/no167"
            },
            {
              name: "読者アンケート"
            }
          ]}
        />
        <p>県民だより夏号についてのご意見をお寄せください。抽選で下記の賞品をプレゼント！<br />
          次のように記入して、はがき等でご応募ください。</p>
        <p css={style.notetTxt}>※プレゼントは選べません。</p>
        
        <img
          src={`${basePath}/no167/img/4-9.png`}
          alt="ハガキの記入例"
          css={style.img(400)}
        />
        
        <p>メールアドレス：<a href="mailto:kenmindayori@pref.niigata.lg.jp">kenmindayori@pref.niigata.lg.jp</a></p>
        
        <p>〔締切〕<span css={style.emphasisWeight}>令和6年8月31日（土）</span>（当日消印有効）<br />〔発表〕当選者の発表は発送をもってかえさせていただきます。</p>
        
        <p>アンケートフォームは
          <a
            href="https://apply.e-tumo.jp/pref-niigata-u/offer/offerDetail_initDisplay?tempSeq=10982&accessFrom="
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <hr />
        
        <h4 css={style.subTitle02}>瀬波の湯【10名】</h4>
        <img
          src={`${basePath}/no167/img/4-10.png`}
          alt="瀬波の湯"
          css={style.img(250, "15px 0 0 0")}
        />
        <p>開湯120周年を迎える瀬波温泉の名湯をご家庭で楽しめます。95度もある源泉が溶かし込んだ豊富すぎる温泉成分が魅力です。</p>
        
        <hr />
        
        <h4 css={style.subTitle02}>「大地の芸術祭 越後妻有 アートトリエンナーレ2024」作品鑑賞パスポート【3名】</h4>
        <img
          src={`${basePath}/no167/img/4-11.png`}
          alt="「大地の芸術祭 越後妻有 アートトリエンナーレ2024」作品鑑賞パスポート"
          css={style.img(250, "15px 0 0 0")}
        />
        <p>300点以上ある作品をお得に鑑賞でき、スタンプラリーや各種割引などの特典も受けられるパスポートです！</p>
        
        <hr />
        
        <h4 css={style.subTitle02}>越の丸茄子（こしのまるなす）【5名】</h4>
        <img
          src={`${basePath}/no167/img/4-12.png`}
          alt="越の丸茄子"
          css={style.img(300, "15px 0 0 0")}
        />
        <p>糸魚川市の特産品「越の丸茄子」は、口に入れたときに感じる甘味と、大ぶりな実の食感から、「大トロ」とまで言われる絶品なすです。色が濃くて光沢があるため、見るからに美味しそう！<br />1箱9玉入×1箱でお届けします。</p>
        
        <hr />
        
        <h4 css={style.subTitle02}>ラムアンシャンテ【5名】</h4>
        <img
          src={`${basePath}/no167/img/4-13.png`}
          alt="ラムアンシャンテ"
          css={style.img(250, "15px 0 0 0")}
        />
        <p>南佐渡産の柿をラム酒に漬け込んだ、今までにない新しいスイーツ。お茶うけや、ワインなどのおつまみにおすすめです。※アルコールを含んでいますので、お子さんやアルコールに弱い方、妊娠、授乳期の方、運転時等はご注意下さい。</p>
        
        <hr />
        
        <p css={style.notetTxt}>【個人情報の取り扱いについて】ご記入いただいた個人情報は、プレゼントの抽選・発送および統計資料の作成に利用します。</p>
        
        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
